import { render, staticRenderFns } from "./VisitStatisticsDept.vue?vue&type=template&id=1cbb8d5a&scoped=true"
import script from "./VisitStatisticsDept.vue?vue&type=script&lang=js"
export * from "./VisitStatisticsDept.vue?vue&type=script&lang=js"
import style0 from "./VisitStatisticsDept.vue?vue&type=style&index=0&id=1cbb8d5a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cbb8d5a",
  null
  
)

export default component.exports